import { PageHead, Card, Empty } from "../components/kit";

/* Temporary page body used while each real page is ported (P1 step 2+).
   Renders inside the shell so routing/nav/kit can be verified end-to-end. */
export function Placeholder({ id, label }: { id: string; label: string }) {
  return (
    <div className="page">
      <PageHead title={label} sub={`The ${label} surface is being built in this phase.`} />
      <Card title="Coming up" icon="hammer">
        <Empty icon="sparkles">
          {id} — ported from the Adaptr Human prototype next.
        </Empty>
      </Card>
    </div>
  );
}
